var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBolsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47.5,
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 55.8889C46.7778 55.8889 45.7319 55.4541 44.8622 54.5844C43.9926 53.7148 43.557 52.6681 43.5556 51.4444C43.5541 50.2207 43.9896 49.1748 44.8622 48.3067C45.7348 47.4385 46.7807 47.003 48 47C49.2193 46.997 50.2659 47.4326 51.14 48.3067C52.0141 49.1807 52.4489 50.2267 52.4444 51.4444C52.44 52.6622 52.0052 53.7089 51.14 54.5844C50.2748 55.46 49.2281 55.8948 48 55.8889ZM37.7222 35.8889H58.2778L61.1111 30.2222C61.4815 29.4815 61.4533 28.7593 61.0267 28.0556C60.6 27.3519 59.9615 27 59.1111 27H36.8889C36.037 27 35.3985 27.3519 34.9733 28.0556C34.5481 28.7593 34.52 29.4815 34.8889 30.2222L37.7222 35.8889ZM40 67H56C59.3333 67 62.1667 65.843 64.5 63.5289C66.8333 61.2148 68 58.3719 68 55C68 53.5926 67.7593 52.2222 67.2778 50.8889C66.7963 49.5556 66.1111 48.3519 65.2222 47.2778L59.4444 40.3333H36.5556L30.7778 47.2778C29.8889 48.3519 29.2037 49.5556 28.7222 50.8889C28.2407 52.2222 28 53.5926 28 55C28 58.3704 29.1578 61.2133 31.4733 63.5289C33.7889 65.8444 36.6311 67.0015 40 67Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 0,
    y1: 0,
    x2: 95,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F1E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBolsa);
export default __webpack_public_path__ + "static/media/ic_bolsa.8c88a1bcc277ebaff72125f1673cc71e.svg";
export { ForwardRef as ReactComponent };